/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FunctionComponent, useCallback } from 'react';
import Loader from 'react-loader-spinner';
import { useDispatch } from 'react-redux';
import { closeDialog } from '../../../app/dialog/dialog.actions';
import { dialogSelectors } from '../../../app/dialog/dialog.selectors';
import { saveCropCounter, saveFormAvatar } from '../../../app/page/page-storage/users/user-form/user-form.actions';
import { useApiRequestState } from '../../../utils/api.utils';
import { useSelectWithParams } from '../../../utils/selector.utils';
import { CompanyToolsCategoryForm } from '../../pages/AgencyToolsPage/CompanyToolsCategoryForm';
import { SubmitButton } from '../../pages/common/forms/SubmitButton';
import { ConnectedDialog } from '../ConnectedDialog';
import { ICompanyToolsCategoryFormDialogProps } from './types';

export const CompanyToolsCategoryFormDialog: FunctionComponent = () => {
  const dispatch = useDispatch();
  const props = useSelectWithParams(
    dialogSelectors.selectDialogProps,
    'companyToolsCategoryFormDialog',
  ) as ICompanyToolsCategoryFormDialogProps;

  const isEditing = Boolean(props?.data);
  const [createShowLoader, createError] = useApiRequestState('createCompanyToolsCategory');
  const [updateShowLoader, updateError] = useApiRequestState('updateCompanyToolsCategory');

  const showLoader = isEditing ? updateShowLoader : createShowLoader;
  const error = isEditing ? updateError && !updateShowLoader : createError && !createShowLoader;

  const onClose = useCallback(() => {
    dispatch(closeDialog('companyToolsCategoryFormDialog'));
    dispatch(saveFormAvatar(''));
    dispatch(saveCropCounter(0));
  }, [dispatch]);

  return (
    <ConnectedDialog dialogKey="companyToolsCategoryFormDialog">
      <div className="popup new_team_popup mid-popup isVisible">
        <div className="panel">
          <div className="panel-header small-header flex jcsb">
            <h3>{props?.data ? 'Edit category' : 'Add category'}</h3>
            <span className="close-popup close">
              {showLoader && <Loader type="TailSpin" color="var(--theme-primary-color)" height={20} width={20} />}
              {error && !showLoader && <p style={{ color: 'red' }}> Something went wrong </p>}
            </span>
          </div>
          <div className="panel-body pt-0" style={{ maxHeight: '500px' }}>
            <CompanyToolsCategoryForm {...props} />
          </div>

          <div className="panel-footer no-border flex jcr">
            <a className="link blueGray mr-2 close" title="" onClick={onClose}>
              Close
            </a>
            {isEditing ? (
              <SubmitButton apiKey="updateCompanyToolsCategory" formName="company-tools-category-form" text="Save" />
            ) : (
              <SubmitButton apiKey="createCompanyToolsCategory" formName="company-tools-category-form" text="Save" />
            )}
          </div>
        </div>
      </div>
    </ConnectedDialog>
  );
};
